import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { BuildsFacade } from 'mbs-ui-shared@facades/builds.facade';
import { BuildType } from 'mbs-ui-shared@models';
import { BuildOsType, ConnectFromBuild } from 'mbs-ui-shared@models/build';
import { AgentType } from 'mbs-ui-shared@models/Computer';
import { ConnectSettingsService } from 'mbs-ui-shared@services/connect.settings.service';
import { EnvironmentService } from 'mbs-ui-shared@services/environments.service';
import { filter, map } from 'rxjs';

import { DownloadBuildComponent } from 'mbs-ui-shared@components/download-build/download-build.component';

import { AsyncPipe, CommonModule } from '@angular/common';

import { I18NextPipe } from 'angular-i18next';

@UntilDestroy()
@Component({
  selector: 'mbs-download-connect',
  templateUrl: './download-connect.component.html',
  styleUrls: ['./download-connect.component.scss'],
  imports: [AsyncPipe, CommonModule, DownloadBuildComponent, I18NextPipe]
})
export class DownloadConnectComponent {
  private buildsFacade = inject(BuildsFacade);
  private connectSettings = inject(ConnectSettingsService);
  environment = inject(EnvironmentService);

  public readonly buildOsType = BuildOsType;
  public readonly type = AgentType.RA;
  public readonly keys = Object.keys;
  public readonly raClientConfig = {
    mac: 'download-connect-icon fa fa-apple text-lg',
    ios: 'download-connect-icon fa fa-apple text-lg',
    android: 'download-connect-icon fa fa-android text-lg'
  };
  public readonly elementSelectors = {
    name: {
      windows: 'downloads-panel--ra-tab--windows-link',
      mac: 'downloads-panel--ra-tab--mac-link',
      ios: 'downloads-panel--ra-tab--ios-link',
      android: 'downloads-panel--ra-tab--android-link'
    }
  };
  public connectClientUrl: string = this.environment.raDownloadURL.windows;
  public builds$ = this.buildsFacade.builds$.pipe(
    untilDestroyed(this),
    filter(Boolean),
    map((builds) => builds.filter(({ mbsBuildType }) => mbsBuildType === BuildType.CBLRA || mbsBuildType === BuildType.MacRA))
  );

  public connectFromBuilds$ = this.buildsFacade.connectFromBuilds$;

  @Output() configureButtonClick = new EventEmitter<boolean>();

  @Input() hideConnectFrom = false;

  constructor() {
    this.connectSettings.getConnectClientBuild().subscribe((connectClientUrl) => {
      this.connectClientUrl = connectClientUrl;
    });
  }

  public getDownloadLink(builds: Array<ConnectFromBuild>, buildOsType: BuildOsType) {
    return builds?.find(({ buildOs }) => buildOs == buildOsType)?.downloadLink || this.connectClientUrl;
  }
}
